/**
 * Scrolls the message element (`data-message-id`) to the centre of its scroll area and
 * returns whether it was found. Instant under `prefers-reduced-motion`, smooth otherwise.
 * The id may come from a URL or from stored data: `CSS.escape` keeps a crafted value from
 * changing the selector (T-02-23).
 */
export function scrollMessageToCenter(
  messageId: string,
  root: ParentNode = document,
): boolean {
  const el = root.querySelector<HTMLElement>(
    `[data-message-id="${CSS.escape(messageId)}"]`,
  );
  if (!el) return false;
  const reduced =
    typeof window.matchMedia === "function" &&
    window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  el.scrollIntoView({ behavior: reduced ? "instant" : "smooth", block: "center" });
  return true;
}
